/* global console */

YUI.add('news-list', function(Y) {

    "use strict";

    var HOST = "host",
        FEED_URL = "url",
        FEED_DATA = "feedData",
        COUNT_ATTR = "count",
        DATE_HEADER_FORMAT_ATTR = "dateheaderformat",
		DESCRIPTION_ATTR = "description",
		IMAGE_ATTR = "image",
        PUBDATE_ATTR = "pubdate",
        PUBDATE_FORMAT_ATTR = "pubdateformat",
        PUBDATE_FORMAT_DEFAULT = "MMMM D, YYYY",
        PUBDATE_LOCATION_ATTR = "pubdatelocation",
        SORT_ATTR = "sort",
        TITLE_KEY = "title",
        TITLE_URL_KEY = "titleurl",

        NEWS_ITEM_PARTIAL =
            "<article>" +
            "{{#if pubdateabovetitle}}<div class='ksu-news-date'>{{friendlyDate moment}}</div>{{/if}}" +
            "<h5>" +
            "{{#if imageurl}}<img src='{{imageurl}}' alt='{{media:title}}' />{{/if}}" +
            "<a href='{{link}}'>{{title}}</a>{{#if pubdateaftertitle}}<span class='ksu-news-date'>, {{friendlyDate moment}}</span>{{/if}}</h5>" +
            "{{#if pubdatebelowtitle}}<div class='ksu-news-date'>{{friendlyDate moment}}</div>{{/if}}" +
            "{{#if description}}<p>{{{description}}}</p>{{/if}}" +
            "{{#if pubdateend}}<div class='ksu-news-date'>{{friendlyDate moment}}</div>{{/if}}" +
            "</article>",

        TEMPLATE =
            "<section class='ksu-news-section{{#if desc_flag}} ksu-news-with-desc{{/if}}{{#if img_flag}} ksu-news-with-img{{/if}}'>" +

            "{{#if linkedheading}}" +
                   "<h4>{{linkedheading}}</h4>" +
            "{{/if}}" +

                "{{#each item}}{{#if header}}<h4>{{value}}</h4>{{else}}{{> article}}{{/if}}{{/each}}" +

            "</section>";


    /**
     * Convert a human-specified string into a boolean value.
     *
     * The returned value will be true if the passed argument
     * is "yes", "true", or "on", in any case, and potentially with
     * leading and trailing blanks.
     *
     */
    var forceBoolean = function(val) {

        return (/^\s*(yes|true|on)\s*$/i).test(val);

    };


    /* NewsList class constructor */
    var NewsList = function(config) {
        NewsList.superclass.constructor.apply(this, arguments);
    };

    /*
     * Required NAME static field, to identify the class and
     * used as an event prefix, to generate class names etc. (set to the
     * class name in camel case).
     */
    NewsList.NAME = "NewsList";

    /*
     * Required NS static field, to identify the property on the host which will,
     * be used to refer to the plugin instance ( e.g. host.feature.doSomething() )
     */
    NewsList.NS = "NewsList";

    /*
     * The attributes for the plugin.
     */
    NewsList.ATTRS = {
        url: {
        },

        feedData: {},    // Stores the retrieved data

        count: {
            value: 5
        },

        dateheaderformat: {
            value: ""
        },

        description: {
            value: false,
			setter: forceBoolean
        },

        image: {
            value: false,
			setter: forceBoolean
        },

        pubdate: {
            value: ""
        },

        pubdateformat: {
            value: "",
            getter: function() {
                return this.value || PUBDATE_FORMAT_DEFAULT;
            }
        },

        pubdatelocation: {
            value: "aftertitle"
        },

        sort: {
            value: ""   // Anything other than "descending" menas ascending
        }
    };


    var wrapLink = function(html, url, extraLinkAttr) {

        html = html || "";

        if (html && url) {
            html = "<a href='" + url + "'" +
                   (extraLinkAttr ? " " + extraLinkAttr : "") +  ">" + html + "</a>";
        }

        return html;
    };


    var ascendingDate = function(a, b) {

        var aval, bval;

        aval = a.pubdatesortable || 0;
        bval = b.pubdatesortable || 0;
        if (aval < bval) {
            return -1;
        }
        if (aval > bval) {
            return 1;
        }

        return 0;

    };


    var descendingDate = function(a, b) {

        return -ascendingDate(a, b);

    };


    var augmentNewsItems = function(channel, pubdatefilter, datelocation) {

        var i, item, pubdate, pubdatefiltermoment, filtertype;

        filtertype = "";
        if (pubdatefilter.length===4) {
            filtertype = "year";
            pubdatefiltermoment = moment(pubdatefilter, 'YYYY', true);
        } else if (pubdatefilter.length===7) {
            filtertype = "month";
            pubdatefiltermoment = moment(pubdatefilter, 'YYYY-MM', true);
        }

        for (i = 0; i < channel.item.length; i++) {
            item = channel.item[i];
			item.index = i;   // Keep an index for each item to create a stable sort.

            // If the description has been turned off, then delete the corresponding property.
			if (!channel.desc_flag) {
                item.description = "";
			}

            pubdate = item.pubDate;   // In the RSS-standard format, e.g., "Tue, 27 Jan 2015 08:00:00 +0000".
            // The RFC822 standard allows timezone names such as "EST".  This code does *not* handle these.
            // None of the feeds from OU Campus use that format, so I don't care much.

			// There may not be a pubDate element.  If omitted, use January 1, 1900, i.e., put the undated item first
            pubdate = pubdate ? moment(pubdate.substr(5), "DD MMM YYYY HH:mm:ss ZZ", true) : moment("1900-01-01");
            if (pubdate.isValid()) {
                if (filtertype && !pubdate.isSame(pubdatefiltermoment, filtertype)) {
                    delete channel.item[i];
                }

                item.moment = pubdate;                       // Keep a reference to the moment object...
                item.pubdatesortable = pubdate.valueOf();    // ...and add an easily-sorted version.
                /* Datelocation should be either 'abovetitle',  'aftertitle', 'belowtitle', 'end', or 'none'.
                */
                if (datelocation) {
                    item['pubdate' + datelocation] = 1;
                }

				/* Create a new property to contain the URL to an image to use, if any.
				 * This defaults to the first media item's thumbnail, or its full URL if
				 * no thumbnail is available.
				 */
				if (channel.img_flag && item['media:content']) {
					item.imageurl = item['media:content'].url;
					if (item['media:content']['media:thumbnail']) {
						item.imageurl = item['media:content']['media:thumbnail'].url;
					}
				}
            }

        }
    };


    var insertHeaders = function(channel, dateheaderformat) {

        var i, item, prevheader = "", header, newlist = [];

        if (!dateheaderformat) {
            return;
        }

        for (i = 0; i < channel.item.length; i++) {
            item = channel.item[i];
			// Items removed because they are outside the date file specification are undefined.
			if (!item) {
				continue;
			}

            header = item.moment.format(dateheaderformat);
            if (header !== prevheader) {
                newlist.push({header: 1, value: header});
                prevheader = header;
            }

            newlist.push(item);
        }

        channel.item = newlist;
    };


    // Private variables
    var TEXT_NODE = 3,
	    CDATA_SECTION_NODE = 4,
        COMMENT_NODE = 8,
        whitespace = /^\s*$/;

    var skipDistractions = function(node) {

       while (node  &&  (node.nodeType===TEXT_NODE  &&  whitespace.test(node.nodeValue))) {
          node = node.nextSibling;
       }

       return node;
    };


    var firstChild = function(node) {

       return skipDistractions(node.firstChild);

    };


    var nextSibling = function(node) {

       return skipDistractions(node.nextSibling);

    };


    /**
     * Handle a single DOM element and populate the corresponding object properties
     *
     *  @param o the object or array being built.
     *  @param el the element to be handled
     */
    var parseElement = function(o, root) {

       var i;
       var parent, child;
       var attrs, attr, lastattr;

       attrs = root.attributes;
    //    lastattr = "";
       for (i = 0; i < attrs.length; i++) {
          attr = attrs[i];
          o[attr.nodeName] = attr.nodeValue;
        //   lastattr = attr.nodeValue;
       }

          parent = firstChild(root);
          while (parent) {
          	 attrs = parent.attributes;
			 if (attrs) {
       		 	for (i = 0; i < attrs.length; i++) {
          			attr = attrs[i];
          			o[attr.nodeName] = attr.nodeValue;
				}
       		 }
             child = firstChild(parent);
             if (child) {
                if (child.nodeType===TEXT_NODE || child.nodeType===CDATA_SECTION_NODE) {
                    o[parent.nodeName] = child.nodeValue;
                } else if (!o[parent.nodeName]) {
                    o[parent.nodeName] = parseElement({}, parent);
                } else if (o[parent.nodeName].push) {
                    o[parent.nodeName].push(parseElement({}, parent));
                } else {
                    o[parent.nodeName] = [o[parent.nodeName], parseElement({}, parent)];
                }
            }

             parent = nextSibling(parent);
          }

          return o;

       };


        var transformDomToObj = function(doc) {

            var result;

            if (!doc.getElementsByTagName) {
                return;
            }

            result = {};
            parseElement(result, doc.firstChild);

            return result;

       };


    var insertFeed = function() {

        var ajaxdata, count, channel, linkedheading, html, template;

        ajaxdata = this.get(FEED_DATA);
        if (!ajaxdata) {
            console.log("No feed data available to insert");
            return;
        }


        template = Handlebars.compile(TEMPLATE);


        linkedheading = wrapLink(this.get(TITLE_KEY), this.get(TITLE_URL_KEY));

        channel = transformDomToObj(ajaxdata.responseXML).channel;

        // Copy some data to the channel object so it can be conveniently used by the formatting Templates
		channel.desc_flag = this.get(DESCRIPTION_ATTR);
		channel.img_flag = this.get(IMAGE_ATTR);

		// TEMP fix for feeds with only one item
		if (!channel.item.length) {
			channel.item = [ channel.item ];
		}

		// Add properties to each RSS item's object to make the display friendlier.
        augmentNewsItems(channel, this.get(PUBDATE_ATTR), this.get(PUBDATE_LOCATION_ATTR));

        channel.item.sort(this.get(SORT_ATTR)==='descending' ? descendingDate : ascendingDate);

        /* If fewer items are to be displayed than are available, clip the item array. */
        count = this.get(COUNT_ATTR);
        if (count < channel.item.length) {
            channel.item.length = count;
        }

        insertHeaders(channel, this.get(DATE_HEADER_FORMAT_ATTR));

        // console.log("formatting", channel);
        html = template(channel);

        this.get(HOST).setContent(html);

    };


    var readFeed = function(id, response) {

        console.log("readFeed", this, arguments);

        this.set(FEED_DATA, response);
        insertFeed.call(this);

    };


    var retrieveFeed = function() {

        var url;

        url = this.get(FEED_URL);
        if (!url) {
            console.log("Skipping NewsList insertion -- no feed URL defined");
            return;
        }

        console.log("Retrieving", url);

        this.ioTransaction = Y.io(url, {on: {success: readFeed}, context: this});
    };


    /* NewsList extends the base Plugin.Base class */
    Y.extend(NewsList, Y.Plugin.Base, {
        initializer: function(config) {
            var dateformat = this.get(PUBDATE_FORMAT_ATTR);

            console.log("Initializing", this.name);

            Handlebars.registerHelper('friendlyDate', function(moment) {

                console.log("friendlydate", this, arguments);

                return moment ? moment.format(dateformat) : "";
            });

            Handlebars.registerPartial('article', NEWS_ITEM_PARTIAL);

            // If the feed hasn't been set yet, this is OK.
            this.render();

        },

        render: function() {

            var data;

            console.log("Rendering", this.name);

            /*
             * If the feed data has not already been retrieved, that has to happen first.
             */
            data = this.get(FEED_DATA);
            if (!data) {
                retrieveFeed.call(this);
                return;
            }

            insertFeed();
        }

    });
    //console.log("assigning", NewsList);
    Y.namespace("Plugin").NewsList = NewsList;

}, '1.0.0' ,{requires:["node", "base", "plugin", "io-base", "datatype-date"]});
